/** 全局挂载文件 2022-09-16 黄金龙
 ** 
 ** 使用说明：需要挂载到Vue.prototype上的组件、插件、方法，都在此文件中注入，无需重复在main.js中引入和use
 ** 拓展：每个域独立的公共方法可在此处挂载，但方法文件放在“域文件夹”内部，防止公共common文件越来越大。
 **       一次挂载，全局通用，调用如 this.$orderActions.xxx
 ** 举例：1. 公共插件：echarts，在此处注入即可，无需在main.js中单独引入和注入，注入后直接this.$echarts调用
 **       2.只适用于订单域的公共方法：OrderActions，在此处注入，将Vue.prototype、store参数传入，在订单域使用this.$orderActions.xxx调用
 ** 备注：1.该文件只适用于web项目的所有域，不适用于合约域、内容域、seo
 **       2.每个域的独立公共方法需要注意命名空间，不要重复
 **/
import store from '~/store/index.js';
import OrderActions from '~/pages/order/plugins/actions.js';

export default {
  install: (Vue) => {
    // 挂载全局常量
    Vue.prototype.mousedownAction = false;
    Vue.prototype.list_size = 100;
    Vue.prototype.tab_size = 10;

    // 挂载全局通用插件
    Vue.prototype.$echarts = echarts;

    // 挂载全局通用方法
    Vue.prototype.$bus = new Vue();

    // 挂载【订单域】的局部通用方法
    Vue.prototype.$orderActions = new OrderActions({ vueProto: Vue.prototype, vueStore: store });

    // 挂载其他域的局部通用方法
    // xxxx
  }
};
